import React from 'react';
import { cn } from './cn';

export type IconButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'ghost' | 'soft';
  size?: 'sm' | 'md';
};

export function IconButton({ className, variant = 'ghost', size = 'md', ...props }: IconButtonProps) {
  const sizes = size === 'sm' ? 'h-9 w-9 rounded-lg' : 'h-10 w-10 rounded-xl';
  const variants =
    variant === 'soft'
      ? 'bg-surface-overlay/40 text-text-secondary hover:text-text-primary hover:bg-surface-overlay/60 border border-surface-border'
      : 'text-text-secondary hover:text-text-primary hover:bg-surface-overlay/35';

  return (
    <button
      {...props}
      className={cn(
        'inline-flex items-center justify-center transition active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/35 disabled:opacity-50',
        sizes,
        variants,
        className,
      )}
    />
  );
}

